export function unwrapMultiFamilyFares(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (response && Array.isArray(response.data)) {
    return response.data;
  }

  return [];
}
// piso el total del primer fare debido a que  LLeego no esta retornando el fee.
export function mergeAvailTotalIntoFirstFare(fares, availTotal) {
  if (!Array.isArray(fares) || fares.length === 0) {
    return fares ?? [];
  }

  if (typeof availTotal !== 'number' || !Number.isFinite(availTotal)) {
    return fares;
  }
  if(fares[0].total !== availTotal) {
    console.log('fares[0].total !== availTotal', fares[0].total, availTotal);
  }
  return [{ ...fares[0], total: availTotal }, ...fares.slice(1)];
}
